import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import * as S from "./PrivateStyle";
import { Outlet, useLocation } from "react-router-dom";
import { useStateValue } from "../../contextAPI/StateProvider";
import ReactGA from "react-ga4";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

// Routes
import privateRoutesList from "../../routes/privateRoutesList";
import PrivateRoute from "../../routes/components/PrivateRoute";
import { Routes } from "../../utils/constants";

// Components
import Sidebar from "./shared/sidebar";

// GraphQL
import { useQuery } from "@apollo/client";
import { QUERY_GET_DOCTOR_DATA } from "../../graphql/queries/Doctor";

// Hooks
import useDoctorData from "../../hooks/useDoctorData";
import GenerativeAI from "./generativeAI";
import GenerativeAIMedpalm from "./generativeAIMedpalm";
import Modal from "../../utils/modal";
import ModalAddEventCalendar from "./agenda/components/modalAddEventCalendar";
import { Actions } from "../../utils/actionsIds";
import useRecordNavigation from "../../hooks/useRecordNavigation";
import ModalCreateInvitePatient from "./shared/modals/modalCreateInvitePatient";
import ModalAddOutcomesEvent from "./shared/modals/modalAddOutcomesEvent";
import FollowUp from "./followUp";
import useInfoToken from "../../hooks/useInfoToken";
import ModalSurveys from "./surveys/components/modalSurveys/ModalSurveys";
import NotesView from "./notesView";
import TransducerView from "./transducerView";

// assets
const florenceLogo = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/monaco-logo.svg`
const florenceMedpalmLogo = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/florence-medpalm.svg`

const ENV = process.env.REACT_APP_ENV;
const DOCTOR_ID = process.env.REACT_APP_DOCTOR_ID_MEDPALM_PROD;

function Private () {
  const { pathname } = useLocation();
  const idPath = pathname.split('/')[1];
  const [t] = useTranslation("global");
  const [{ popUp }] = useStateValue();
  const { saveDoctorData } = useDoctorData();
  const currentPage = privateRoutesList.find(route => route.id === idPath.toLowerCase());
  const [ activeMenu, setActiveMenu ] = useState(false);
  const { recordAction } = useRecordNavigation();
  const webView = Cookies.get('webView');

  const {doctorData} = useDoctorData();

  const { userId } = useInfoToken();

  // eslint-disable-next-line no-unused-vars
  const { data, loading, error } = useQuery(QUERY_GET_DOCTOR_DATA, { variables: { doctorId: userId} });

  const navigate = useNavigate();
  const { CHAT } = Routes;

  const [{ 
    florenceActive,
    medpalmFlorenceActive,
    followUpActive,
    anchoredViewActived
   }, dispatch] = useStateValue();

  const [activeShortcuts, setActiveShortcuts] = useState(false);
  const [addCalendarEvent, setAddCalendarEvent] = useState(false);
  const [createInvitePatientActive, setCreateInvitePatientActive] = useState(false);
  const [sendFillOutSurveyActive, setSendFillOutSurveyActive] = useState(false);
  const [addOutcomesEvent, setAddOutcomesEvent] = useState(false);

  const [maxViewActived, setMaxViewActived] = useState(false);
  const [minimizeActived, setMinimizeActived] = useState(false);

  const [monacoMaxViewActived, setMonacoMaxViewActived] = useState(false);
  const [monacoMinimizeActived, setMonacoMinimizeActived] = useState(false);

  useEffect(() => {
    if(!loading) {
      saveDoctorData(data?.doctor[0]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (ENV === 'production') {
      ReactGA.send({ hitType: "pageview", page: currentPage?.id });
    }
  }, [currentPage]);

  const activeAnchoredViewActived = (active) => {
    dispatch({
      type: "SET_ANCHORED_VIEW_ACTIVE",
      anchoredViewActived: active,
    });
  }

  const activeFlorenceChatbot = () => {
    if(activeShortcuts) {
      setFlorenceView(false);
    } else {
      recordAction(Actions.MONACO.FLORENCE);
      setFlorenceView(true);
    }
  }

  const activeFlorenceMedpalmChatbot = () => {
    if(activeShortcuts) {
      setMedpalmFlorenceView(false);
    } else {
      recordAction(Actions.MONACO.FLORENCE_MEDICOL);
      setMedpalmFlorenceView(true);
    }
  }

  const setFlorenceView = (active) => {
    dispatch({
      type: "SET_FLORENCE_ACTIVE",
      florenceActive: active,
    });
  }

  const setMedpalmFlorenceView = (active) => {
    dispatch({
      type: "SET_MEDPALM_FLORENCE_ACTIVE",
      medpalmFlorenceActive: active,
    });
  }

  const [florenceChats, setFlorenceChats] = useState([
    {
      id: 0,
      name: t("chatbotAI.general.title"),
      activateFunc: activeFlorenceChatbot,
      directActiveFunc: setFlorenceView,
      component: (props) => <GenerativeAI {...props} />,
      styleClass: "iachatbot",
      action: Actions.MONACO.CHAT
    }
  ]) 

  useEffect(() => {
    if(ENV !== 'production' || DOCTOR_ID === doctorData?.id) {
      florenceChats.push(
        {
          id: 1,
          name: "Medpalm",
          activateFunc: activeFlorenceMedpalmChatbot,
          directActiveFunc: setMedpalmFlorenceView,
          component: (props) => <GenerativeAIMedpalm {...props} />,
          styleClass: "iachatbot iachatbot--medpalm",
          action: Actions.MONACO.CHAT_MEDICOL
        }
      )
      setFlorenceChats(florenceChats);
    }
  }, [ENV])

  const [chatbotsSelected, setChabotsSelected] = useState([]);

  useEffect(() => {      
    if(medpalmFlorenceActive && !chatbotsSelected.find(chatbot => chatbot.id === florenceChats[1].id)) {
      setChabotsSelected([...chatbotsSelected, florenceChats[1]]);
    } else {
      setChabotsSelected(chatbotsSelected?.filter(chatbot => chatbot.id !== florenceChats[1].id));
    }
  }, [medpalmFlorenceActive])

   useEffect(() => {
      if(florenceActive && !chatbotsSelected.find(chatbot => chatbot.id === florenceChats[0].id)) {
        setChabotsSelected([...chatbotsSelected, florenceChats[0]]);
      } else {
        setChabotsSelected(chatbotsSelected?.filter(chatbot => chatbot.id !== florenceChats[0].id));
      }
   }, [florenceActive])

  return (
    <S.Private 
      activeModal={popUp.isActive} 
      activeMenu={activeMenu} 
      webView={webView}
      police={currentPage?.id === "police" || currentPage?.id === "monaco"}
      maxViewActived={maxViewActived}
      minimizeActived={minimizeActived}
      monacoMaxViewActived={monacoMaxViewActived}
      monacoMinimizeActived={monacoMinimizeActived}
    >
      {/*   
        <Modal open={true}>
          <ModalPDFReader/>
        </Modal> 
      */}

      <Modal open={addOutcomesEvent}>
        <ModalAddOutcomesEvent
          setCreateEventActive={setAddOutcomesEvent}
        />
      </Modal>

      <Modal open={createInvitePatientActive}>
        <ModalCreateInvitePatient
          setCreateInvitePatientActive={setCreateInvitePatientActive}
        />
      </Modal>
      <Modal open={addCalendarEvent }>
        <ModalAddEventCalendar
          event={null}
          setCardEventSelected={null}
          setCreateEventCalendarActive={setAddCalendarEvent}
        />
      </Modal>
      <Modal open={sendFillOutSurveyActive}>
        <ModalSurveys
          setModalActive={setSendFillOutSurveyActive}
        />
      </Modal>
      <div className="private">
        {
          activeShortcuts &&
          <div className="background-extra-shortcuts" onClick={() => setActiveShortcuts(false)}></div>
        } 
        {
          !activeMenu && 
          currentPage?.id !== "police" && 
          currentPage?.id !== "monaco" &&
          <div className="private__shortcuts">
            <div className="shortcuts">
              {
                activeShortcuts &&
                <div className="extra-shortcut">
                   <div className="shortcut"
                    onClick={
                      () => {
                        setCreateInvitePatientActive(true);
                        recordAction(Actions.SHORTCUT.CREATE_INVITE_PATIENT);
                      }
                    }
                  >
                    <div className="shortcut__info">
                      <div className="shortcut__title">{t("globally.inviteCreatePatient")}</div>
                      <div className="shortcut__description">{t("shortcuts.addInvitePatient.description")}</div>
                    </div>
                    <button className="shortcut__button"
                      style={{backgroundColor: "#36369B"}}
                    >
                      <i className="shortcut__button-icon icon zaia-i-add-user" />
                    </button>
                  </div>

                  <div className="shortcut"
                    onClick={
                      () => {
                        setSendFillOutSurveyActive(true);
                        recordAction(Actions.SHORTCUT.SEND_FILL_OUT_SURVEY);
                      }
                    }
                  >
                    <div className="shortcut__info">
                      <div className="shortcut__title">{t("globally.sendFillOutSurvey")}</div>
                      {/* <div className="shortcut__description">{t("shortcuts.addInvitePatient.description")}</div> */}
                    </div>
                    <button className="shortcut__button"
                      style={{backgroundColor: "#2B97FA"}}
                    >
                      <i className="shortcut__button-icon icon zaia-i-doc-1" />
                    </button>
                  </div>

                  <div className="shortcut"
                    onClick={
                      () => {
                        recordAction(Actions.SHORTCUT.CREATE_OUTCOMES_EVENT);
                        setAddOutcomesEvent(true);
                      }
                    }
                  >
                    <div className="shortcut__info">
                      <div className="shortcut__title">{t("globally.addEvent")}</div>
                      <div className="shortcut__description">{t("shortcuts.addEvent.description")}</div>
                    </div>
                    <button className="shortcut__button"
                      style={{backgroundColor: "#1F1F52"}}
                    >
                      <i className="shortcut__button-icon icon zaia-i-add-event" />
                    </button>
                  </div>
                  <div 
                    className="shortcut"
                    onClick={
                      () => {
                        navigate(CHAT.route);
                        recordAction(Actions.SHORTCUT.SEND_MESSAGE);
                        setActiveShortcuts(false);
                      }
                    }
                  >
                    <div className="shortcut__info">
                      <div className="shortcut__title">{t("shortcuts.sendMessage.title")}</div>
                      <div className="shortcut__description">{t("shortcuts.sendMessage.description")}</div>
                    </div>
                    <button className="shortcut__button"
                      style={{backgroundColor: "#6C6BCC"}}
                      >
                      <i className="shortcut__button-icon icon zaia-i-message-outline" />
                    </button>
                  </div>
                  <div 
                    className="shortcut"
                    onClick={
                      () => {
                        recordAction(Actions.SHORTCUT.CREATE_CALENDAR_EVENT);
                        setAddCalendarEvent(true)
                      }
                    }
                  >
                    <div className="shortcut__info">
                      <div className="shortcut__title">{t("shortcuts.scheduleAppointment.title")}</div>
                      <div className="shortcut__description">{t("shortcuts.scheduleAppointment.description")}</div>
                    </div>
                    <button className="shortcut__button" 
                      style={{backgroundColor: "#F19D38"}}
                    >
                      <i className="shortcut__button-icon icon zaia-i-calender-check" />
                    </button>
                  </div>
                  {/* <div 
                    className="shortcut"
                    onClick={
                      () => {
                        recordAction(Actions.SHORTCUT.CREATE_PRESCRIPTION);
                      }
                    }
                  >
                    <div className="shortcut__info">
                      <div className="shortcut__title">{t("shortcuts.sendMedications.title")}</div>
                      <div className="shortcut__description">{t("shortcuts.sendMedications.description")}</div>
                    </div>
                    <button className="shortcut__button"
                      style={{backgroundColor: "#92D46E"}}
                    >
                      <i className="shortcut__button-icon icon zaia-i-add-medicine"/>
                    </button>
                  </div> */}
                  <button className="button-action" onClick={() => setActiveShortcuts(false)}>
                    <i className="button-action__icon icon zaia-icono-cerrar" />
                  </button>
                </div>
              }
              {
                !activeShortcuts && 
                <button className="button-action" 
                  data-testid="button-action-shortcuts"
                  onClick={
                    () => {
                      setChabotsSelected([]);
                      setFlorenceView();
                      setMedpalmFlorenceView();
                      setActiveShortcuts(true);
                      recordAction(Actions.SHORTCUT.VIEW);
                    }
                  }
                >
                  <i className="button-action__icon icon zaia-icono-agregar" />
                </button>
              }
              {/* Notessss */}
              <button className="button-action" 
                  onClick={
                    () => {
                      activeAnchoredViewActived(1);
                    }
                  }
                >
                <div className="button-action__content">
                  <i className="button-action__icon button-action__icon--notes icon zaia-document"/>
                  <div className="button-action__text">
                    {t("globally.notes")}
                  </div>
                </div>
              </button>
              {/* Transducer */}
              {/* <button className="button-action" 
                  onClick={
                    () => {
                      setAnchoredViewActived(2);
                    }
                  }
                >
                <div className="button-action__content">
                  <i className="button-action__icon button-action__icon--notes icon zaia-document ~changeicon"/>
                </div>
              </button> */}
              {
                florenceChats.map((chat, index) => {
                  return (
                    <button 
                      key={chat.id}
                      className={chat.styleClass}
                      onClick={
                        () => {
                          chat.activateFunc()
                          recordAction(chat.action);
                          activeAnchoredViewActived(3);
                        }
                      }
                    style={
                        {
                          opacity: activeShortcuts ? 0.5 : 1,
                          cursor: activeShortcuts ? "default" : "pointer"
                        }
                      }
                    >
                      <div className="iachatbot__button-logo">
                        <img className="iachatbot__button-florence-logo" src={florenceLogo} alt="F" />
                        {
                          index === 1 &&
                          <div className="iachatbot__button-florence-medpalm-logo">
                            <img className="iachatbot__button-florence-medpalm-logo-img" src={florenceMedpalmLogo} alt="M" />
                          </div>
                        }
                      </div>
                    </button>
                  )
                })
              }

              {
                anchoredViewActived === 1 &&
                <div className="notes__container">
                  <NotesView
                    closeFunc={() => activeAnchoredViewActived(null)}
                    maxHeight="295px"
                    maxViewActived={maxViewActived}
                    setMaxViewActived={setMaxViewActived}
                    minimizeActived={minimizeActived}
                    setMinimizeActived={setMinimizeActived}
                  />
                </div>
              } 

              {/* {
                anchoredViewActived === 2 &&
                <div className="notes__container">
                  <TransducerView
                    closeFunc={() => setAnchoredViewActived(null)}
                    maxHeight="295px"
                    maxViewActived={maxViewActived}
                    setMaxViewActived={setMaxViewActived}
                    minimizeActived={minimizeActived}
                    setMinimizeActived={setMinimizeActived}
                  />
                </div>
              }  */}

              {
                anchoredViewActived === 3 &&
                <div className="iachatbot__container">
                  {
                    chatbotsSelected?.map((chatbot) => {
                      return (
                        <div className="iachatbot__box" 
                          style={
                            {
                              display: (chatbot.id === 0 ? florenceActive : medpalmFlorenceActive ) ? "flex" : "none",
                            }
                          }
                        >
                          <chatbot.component 
                            closeFunc={chatbot.directActiveFunc}
                            maxHeight="295px"
                            maxViewActived={monacoMaxViewActived}
                            setMaxViewActived={setMonacoMaxViewActived}
                            minimizeActived={monacoMinimizeActived}
                            setMinimizeActived={setMonacoMinimizeActived}
                          />
                        </div>
                      )
                    })
                  }
                </div>
              }
            </div>
          </div>
        }

        {
          followUpActive &&
          <div className="follow-up">
            <FollowUp />
          </div>
        }

        {
          currentPage?.id !== "police" && 
          currentPage?.id !== "monaco" &&
          <div className="private__sidebar">
            <Sidebar namePage={currentPage?.id} setActiveMenu={setActiveMenu} />
          </div>
        }
        
        <div className="private__right">
          <div className="private__right-body">
            <div className="private__right-body-content">
              <Outlet />
            </div>
            {
              popUp.isActive ? 
                <div className="private__right-body-modal">
                  <popUp.modal /> 
                </div>
              : null
            }
          </div>
        </div>
      </div>
    </S.Private>
  )

}

export default Private;
